module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project"
  }, [_c('header', {
    staticClass: "project-header"
  }, [_c('h1', {
    staticClass: "project-header__name"
  }, [_vm._v(_vm._s(_vm.projectData.name))]), _vm._v(" "), _c('a', {
    staticClass: "project-header__link",
    attrs: {
      "href": _vm.properLink(_vm.projectData.url),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.projectData.url))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Problem: ")]), _vm._v(_vm._s(_vm.projectData.problem))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Solution: ")]), _vm._v(_vm._s(_vm.projectData.solution))]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.projectData.keywords))])])]), _vm._v(" "), _c('section', {
    staticClass: "project-content",
    attrs: {
      "id": "project-content"
    }
  }, [_vm._l((_vm.projectData.video), function(url, i) {
    return _c('div', {
      staticClass: "project-content__media"
    }, [_c('iframe', {
      attrs: {
        "src": (url),
        "frameborder": "0",
        "type": "text/html",
        "width": "400",
        "height": "200"
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.projectData.media), function(image, i) {
    return _c('div', {
      staticClass: "project-content__media"
    }, [_c('img', {
      staticClass: "project-content__media",
      attrs: {
        "src": _vm.getImage(image)
      }
    })])
  })], 2), _vm._v(" "), _c('footer', {
    staticClass: "cta"
  }, [_c('h2', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Explore more projects")])], 1), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "href": "http://dougblackjr.com/#contact"
    }
  }, [_vm._v("Contact me to get started!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-319eaefa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project.vue
// module id = 46
// module chunks = 0